<div class="header-search">
    <div class="header-search-input-wrapper">
        <i class="fa fa-fw fa-search header-search-icon" *ngIf="!isLoading"></i>
        <div *ngIf="isLoading" class="spinner-border spinner-border-sm header-search-icon" role="status" aria-hidden="true"></div>
        <input class="form-control form-control-sm header-search-input" type="text" placeholder="Search"
               [formControl]="searchControl"
               (focus)="loadSearchResults(searchControl.value)"
               (keydown)="onKeyDown($event)"
               />
        <i *ngIf="searchControl.value"
           class="fa fa-times text-muted header-search-clear"
           (click)="clearSearch()"></i>
    </div>
    <div class="header-search-results-container" *ngIf="results || error">
        <div class="header-search-results dropdown-menu show">

            <div class="alert alert-danger mb-0" *ngIf="error">
                {{ error.message }}
            </div>

            <span *ngIf="results && results.length == 0" class="dropdown-item disabled text-muted">No results were found</span>

            <ng-container *ngIf="results && results.length > 0">
            <div *ngFor="let result of results; let i = index" (contextmenu)="onRightClick($event, result)">
                <a [href]="getResultUrl(result)" class="dropdown-item" [class.active]="i === selectedIndex" [style.opacity]="result.active ? 1 : 0.75">
                    <div class="row gx-2 align-items-center font-12px">
                        <div class="col-auto me-2" style="width: 32px; height: 32px">
                            <app-image
                                [imageSrc]="result.image ? CDN_GLOBAL + result.image : ''"
                                [imagePurpose]="getImagePurpose(result.type)"
                                [initials]="getImageInitials(result)"
                                [class]="result.type === 'User' || result.type === 'Freelancer' || result.type === 'Person' ? 'rounded-circle' : 'rounded'"
                                style="width: 32px; height: 32px; display: block"
                                appUnwrapTag>
                            </app-image>
                        </div>
                        <div class="col" style="min-width: 0">
                            <div class="d-flex align-items-center gap-1">
                                <div class="result-name text-truncate">{{ result.name }}</div>
                                <i *ngIf="truncatedSet.has(i)"
                                   class="fa-solid fa-circle-info text-muted flex-shrink-0"
                                   style="font-size: 11px"
                                   [ngbTooltip]="result.name"
                                   container="body"></i>
                            </div>
                            <div class="text-muted d-flex align-items-center gap-2" style="font-size: 10px">
                                <span>{{ result.type }}</span>
                                <span *ngIf="result.subtitle">{{ result.subtitle }}</span>
                                <span *ngIf="!result.active" class="text-danger">inactive</span>
                            </div>
                        </div>
                    </div>
                </a>
               
            </div>
            </ng-container>
        </div>
    </div>
</div>

<app-right-click-menu
    [visible]="contextMenuVisible"
    [x]="contextMenuX"
    [y]="contextMenuY"
    [item]="contextMenuItem"
    [actions]="contextMenuActions"
    (action)="onContextMenuAction($event)"
    (close)="onContextMenuClose()">
</app-right-click-menu>